import Axios from "axios";
import Store from "@/store/index.js";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";
import SerBusqueda from "@/services/Busqueda/Busqueda.service.js";
import Asistencia from "@/services/AsistenciaGeneral/AsistenciaGeneral.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

var jwt = require("jsonwebtoken");
var privateKey = Store.state.privateKey;

const domain = Store.state.domain;

import xlsxPopulate from "xlsx-populate";

export default {
  registrarPaginaVisitada(modulo, name, url, domain, nrreporte, svindice) {
    // if(){
    var formData = new FormData();
    formData.append("modulo", modulo);
    formData.append("url", url);
    formData.append("tituloPagina", name);
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    formData.append("uslogin", this.ObtenerUserName());
    Axios.post(`${domain}PaginaVisitada`, formData);
    // }
  },
  obtenerArrayDeObjetosConClave(parametro, key) {
    var data = [];
    for (var i in parametro) {
      for (var j in parametro[i]) {
        if (key == j) {
          data.push(`${parametro[i][j]}`);
        }
      }
    }
    return data.toString();
  },
  verificaPropiedadesVaciasObjeto(objeto) {
    let count = 0;
    Object.keys(objeto).forEach((key) => {
      if (objeto[key] == "" || Object.keys(objeto[key]).length == 0) {
        count++;
      }
    });
    return count == Object.keys(objeto).length ? true : false;
  },
  eliminaCookie(cookie) {
    if (document.cookie.indexOf(cookie) != -1) {
      var date = new Date();
      date.setDate(date.getDate() - 1);
      document.cookie = cookie + "=; expires=" + date.toGMTString();
    }
  },
  cerrarSesion(domainNameForApi, informationPage) {
    Axios.post(`${domainNameForApi}signOut`)
      .then((response) => {
        if (response.data) {
          //window.localStorage.clear();
          this.eliminaCookie(informationPage.nameCookiePGV2);
          ManagerLocalStorage.removeLocalStorage(
            informationPage.nameLocalStoragePGV2
          );
          setTimeout(() => {
            location.reload();
          }, 100);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  ExpirarCurrentSession(domainNameForApi, informationPage) {
    Axios.post(`${domainNameForApi}signOut`)
      .then((response) => {
        if (response.data) {
          //window.localStorage.clear();
          this.eliminaCookie(informationPage.nameCookiePGV2);
          ManagerLocalStorage.removeLocalStorage(
            informationPage.nameLocalStoragePGV2
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  //Loading
  abrirCargandoPantalla(vm, text) {
    vm.$vs.loading({
      background: vm.backgroundLoading,
      color: vm.colorLoading,
      scale: 0.45,
      text: text != "" ? text : "",
    });
  },
  cerrarCargandoPantalla(vm) {
    vm.$vs.loading.close(vm.backgroundLoading);
  },
  abrirCargandoBoton(vm, id) {
    vm.$vs.loading({
      background: vm.backgroundLoading,
      color: vm.colorLoading,
      container: id,
      scale: 0.45,
    });
  },
  cerrarCargandoBoton(vm, id) {
    vm.$vs.loading.close(`${id} > .con-vs-loading`);
  },

  //VerificarPermiso
  verificarPermiso(domainNameForApi, ruta, uslogin, permiso) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("permiso", permiso);
    return Axios.post(`${domain.domainNameForApi}${ruta}`, formData);
  },

  verificarPermisoSolo(domainNameForApi, ruta, permiso) {
    let user = this.ObtenerUserName();
    var formData = new FormData();
    formData.append("permiso", permiso);
    formData.append("uslogin", user);
    return Axios.post(`${domain.domainNameForApi}${ruta}`, formData);
  },

  obtenerPermisosMenu(domainNameForApi, ruta) {
    return Axios.post(`${domainNameForApi}${ruta}`);
  },

  //redondear con decimales
  // 'round', valor, -2
  ajustarDecimalRedondeo(type, value, exp) {
    // Si el exp no está definido o es cero...
    if (typeof exp === "undefined" || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // Si el valor no es un número o el exp no es un entero...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
  },

  //Regex
  validarRegex(evt, tipo) {
    //Ejemplo JS Input onkeypress="javascript:return validarRegex(event, 'L')"
    //Ejemplo Vue Input @keypress="validarRegex($event, 'N')"
    //Referencia expresiones regulares https://www.sitepoint.com/expressions-javascript/
    //ND-Solo Números con Decimales  N-Sólo Números  L-Sólo Letras NL-Sólo Letras y Números NCS-Número Cuenta Servicio LE-Letras con espacios  ND2-Número con 2 decimales NM-Moneda(1, 1.0, 1.01) NMD-Moneda con decimales libres  LV = Solo Letras asignando una variable NV = Solo Numeros asignando una variable NLV = Solo Numeros y Letras asignando una variable NMDV-Moneda con decimales libres asignando una variable UUID-Facturas NG | Sólo números y guiones  LNE | Solo letras, numeros y espacios; NDN | Números decimales negativos
    //EMAIL-Email en input con separación de comas
    if (tipo == "L") {
      var pattern = /^[A-Za-z]+$/;
      return pattern.test(evt.key)
        ? pattern.test(evt.key)
        : evt.preventDefault();
    }

    if (tipo == "N") {
      var pattern = /^\d+$/;
      return pattern.test(evt.key)
        ? pattern.test(evt.key)
        : evt.preventDefault();
    }

    if (tipo == "LE") {
      var pattern = /^[a-zA-Z\s]*$/;
      return pattern.test(evt.key)
        ? pattern.test(evt.key)
        : evt.preventDefault();
    }

    if (tipo == "NL") {
      var pattern = /^\w+$/;
      return pattern.test(evt.key)
        ? pattern.test(evt.key)
        : evt.preventDefault();
    }

    if (tipo == "ND") {
      var iKeyCode = evt.which ? evt.which : evt.keyCode;
      return iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57)
        ? evt.preventDefault()
        : true;
    }
    if (tipo == "NDN") {
      var iKeyCode = evt.which ? evt.which : evt.keyCode;
      return iKeyCode != 46 &&
        iKeyCode != 45 &&
        iKeyCode > 31 &&
        (iKeyCode < 48 || iKeyCode > 57)
        ? evt.preventDefault()
        : true;
    }

    if (tipo == "NCS") {
      var pattern = /^\d{4}-\d{5}$/;
      return evt.match(pattern) != null ? false : true;
    }

    if (tipo == "ND2") {
      var pattern = /^\d+\.\d{2}$/;
      return evt.match(pattern) != null ? false : true;
    }

    if (tipo == "NM") {
      var pattern = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/;
      return evt.match(pattern) != null ? false : true;
    }

    if (tipo == "NMD") {
      var pattern = /^\s*(?=.*[1-9])\d*(?:\.\d{1,9})?\s*$/;
      return evt.match(pattern) != null ? false : true;
    }

    if (tipo == "NMDB") {
      return /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(evt) ? false : true;
    }

    if (tipo == "LV") {
      return /^[A-Za-z]+$/.test(evt) ? true : false;
    }

    if (tipo == "NV") {
      return /^\d+$/.test(evt) ? true : false;
    }

    if (tipo == "NLV") {
      return /^\w+$/.test(evt) ? true : false;
    }

    if (tipo == "NMDV") {
      return /^\s*(?=.*[1-9])\d*(?:\.\d{1,9})?\s*$/.test(evt) ? true : false;
    }
    if (tipo == "MDV") {
      return /^\$(((\d{1,3},)(\d{3},)*\d{3})|(\d{1,3}))\.\d{2}$/.test(evt)
        ? true
        : /^(\d{1,3}(\,\d{3})*|(\d+))(\.\d{2})?$/.test(evt)
        ? true
        : /^[0-9,$]*(?:\.\d+)?$/.test(evt)
        ? true
        : false;

      return /(?:- ?)?\d+(?:,\d+)?/.test(evt) ? true : false;
    }
    if (tipo == "NG") {
      var pattern = /^[0-9-]*$/;
      return pattern.test(evt.key)
        ? pattern.test(evt.key)
        : evt.preventDefault();
    }
    if (tipo == "LNE") {
      var pattern = /^[A-Za-z0-9/.#\s]+$/g;
      return pattern.test(evt.key)
        ? pattern.test(evt.key)
        : evt.preventDefault();
    }

    if (tipo == "UUID") {
      var pattern =
        /\b[0-9A-z]{8}\b-[0-9A-z]{4}-[0-9A-z]{4}-[0-9A-z]{4}-\b[0-9A-z]{12}\b/g;
      return evt.match(pattern) != null ? false : true;
    }

    if (tipo == "EMAIL") {
      var pattern =
        /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/g;
      return evt.match(pattern) != null ? false : true;
    }
    if (tipo == "NDV") {
      return /^\d+(\.\d{1,5})?$/.test(evt) ? true : false;
    }
    if (tipo == "NU") {
      var pattern = /(?=.*\d)/;
      return evt.match(pattern) != null ? false : true;
    }
    if (tipo == "LT") {
      //var pattern = /(?=.*[A-Za-z])/;
      var pattern = /^(?=.*[a-z])(?=.*[A-Z]).*$/;
      return evt.match(pattern) != null ? false : true;
    }
    if (tipo == "SC") {
      var pattern = /([#$%&/()?_!.*@+:,])/;
      return evt.match(pattern) != null ? false : true;
    }
  },
  EvaluarInvalidos(cadena) {
    var RegExpCharEspecial = /[\,\<\>\-\^\"\'\=\ñÑ\{\}\;]/;
    var resultado = cadena.match(RegExpCharEspecial);
    if (resultado != null) {
      return true;
    } else {
      return false;
    }
  },
  validaRFC(rfc) {
    var lol = rfc.trim().toUpperCase();
    var rf = /^[a-zA-Z]{3,4}(\d{6})((\D|\d){2,3})?$/;
    var validado = lol.match(rf);
    return validado ? true : false;
  },
  validaRFCMoral(rfc) {
    var lol = rfc.trim().toUpperCase();
    var rf = /^[a-zA-Z]{3}?(\d{6})((\D|\d){3})?$/;
    var validado = lol.match(rf);
    return validado ? true : false;
  },

  validaCurp(curp) {
    var lol = curp.trim();
    var crp =
      /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
    var validado = lol.match(crp);
    return validado ? true : false;
  },
  validaFax(fax) {
    return /^(\+?\d{1,}(\s?|\-?)\d*(\s?|\-?)\(?\d{2,}\)?(\s?|\-?)\d{3,}\s?\d{3,})$/.test(
      fax
    )
      ? true
      : false;
  },
  validaUrl(url) {
    return /^(w{3}?)+(\.[\w\-]+)\.+(\w{2,}?)+[/#?]?.*$/.test(url)
      ? true
      : false;
    //return /^(w{3}?)+(\.[\w\-]+)\.+[/#?]?.*$/.test(url) ? true : false;
    //return /^https?:\/\/[\w\-]+(\.[\w\-]+)\.+[/#?]?.*$/.test(url) ? true : false;
  },

  //Imagen a Base 64
  imagenBase64(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = url;
    });
  },

  //Conversión de dinero a letras
  mod(dividendo, divisor) {
    let resDiv = dividendo / divisor;
    let parteEnt = Math.floor(resDiv);
    let parteFrac = resDiv - parteEnt;
    let modulo = this.ajustarDecimalRedondeo("round", parteFrac * divisor, -2);
    return modulo;
  },

  ObtenerParteEntDiv(dividendo, divisor) {
    let resDiv = dividendo / divisor;
    let parteEntDiv = Math.floor(resDiv);
    return parteEntDiv;
  },
  fraction_part(dividendo, divisor) {
    let resDiv = dividendo / divisor;
    let f_part = Math.floor(resDiv);
    return f_part;
  },
  string_literal_conversion(number) {
    let centenas = this.ObtenerParteEntDiv(number, 100);

    number = this.mod(number, 100);

    let decenas = this.ObtenerParteEntDiv(number, 10);
    number = this.mod(number, 10);

    let unidades = this.ObtenerParteEntDiv(number, 1);
    number = this.mod(number, 1);
    let string_hundreds = "";
    let string_tens = "";
    let string_units = "";
    if (centenas == 1) string_hundreds = "ciento ";
    if (centenas == 2) string_hundreds = "doscientos ";
    if (centenas == 3) string_hundreds = "trescientos ";
    if (centenas == 4) string_hundreds = "cuatrocientos ";
    if (centenas == 5) string_hundreds = "quinientos ";
    if (centenas == 6) string_hundreds = "seiscientos ";
    if (centenas == 7) string_hundreds = "setecientos ";
    if (centenas == 8) string_hundreds = "ochocientos ";
    if (centenas == 9) string_hundreds = "novecientos ";
    if (decenas == 1) {
      if (unidades == 1) string_tens = "once";
      if (unidades == 2) string_tens = "doce";
      if (unidades == 3) string_tens = "trece";
      if (unidades == 4) string_tens = "catorce";
      if (unidades == 5) string_tens = "quince";
      if (unidades == 6) string_tens = "dieciseis";
      if (unidades == 7) string_tens = "diecisiete";
      if (unidades == 8) string_tens = "dieciocho";
      if (unidades == 9) string_tens = "diecinueve";
    }
    if (decenas == 2) string_tens = "veinti";
    if (decenas == 3) string_tens = "treinta";
    if (decenas == 4) string_tens = "cuarenta";
    if (decenas == 5) string_tens = "cincuenta";
    if (decenas == 6) string_tens = "sesenta";
    if (decenas == 7) string_tens = "setenta";
    if (decenas == 8) string_tens = "ochenta";
    if (decenas == 9) string_tens = "noventa";
    if (decenas == 1) {
      string_units = "";
    } else {
      if (unidades == 1) string_units = "un";
      if (unidades == 2) string_units = "dos";
      if (unidades == 3) string_units = "tres";
      if (unidades == 4) string_units = "cuatro";
      if (unidades == 5) string_units = "cinco";
      if (unidades == 6) string_units = "seis";
      if (unidades == 7) string_units = "siete";
      if (unidades == 8) string_units = "ocho";
      if (unidades == 9) string_units = "nueve";
    }
    if (centenas == 1 && decenas == 0 && unidades == 0)
      string_hundreds = "cien ";
    if (decenas == 1 && unidades == 0) string_tens = "diez ";
    if (decenas == 2 && unidades == 0) string_tens = "veinte ";
    if (decenas >= 3 && unidades >= 1) string_tens = string_tens + " y ";

    let final_string = `${string_hundreds}${string_tens}${string_units}`;
    return final_string;
  },
  covertirNumerosALetras(number, claveMoneda) {
    let monto = parseInt(number);
    let number1 = number;
    let cent = number1.split(".");
    let centavos = cent[1];
    let millions_final_string = "";
    let thousands_final_string = "";
    let centenas_final_string = "";
    if (centavos == 0 || centavos == undefined) centavos = "00";
    if (number == 0 || number == "") {
      centenas_final_string = " cero ";
    } else {
      let millions = this.ObtenerParteEntDiv(number, 1000000);
      number = this.mod(number, 1000000);
      let descriptor = "";
      descriptor =
        millions != 0
          ? (descriptor =
              millions == 1
                ? (descriptor = " millon ")
                : (descriptor = " millones "))
          : (descriptor = " ");
      millions_final_string =
        this.string_literal_conversion(millions) + descriptor;
      let thousands = this.ObtenerParteEntDiv(number, 1000);
      number = this.mod(number, 1000);
      if (thousands != 1)
        thousands_final_string =
          this.string_literal_conversion(thousands) + " mil ";

      if (thousands == 1) thousands_final_string = " mil ";

      if (thousands < 1) thousands_final_string = " ";

      let centenas = number;
      centenas_final_string = this.string_literal_conversion(centenas);
    }
    let cad =
      millions_final_string + thousands_final_string + centenas_final_string;
    cad = cad.toUpperCase();
    if (centavos.length > 2)
      centavos =
        centavos.substring(2, 3) >= 5
          ? (centavos =
              centavos.substring(0, 1) +
              (parseInt(centavos.substring(1, 2)) + 1).toString())
          : (centavos = centavos.substring(0, 2));
    if (centavos.length == 1) centavos = centavos + "0";
    centavos = centavos + "/100";
    let moneda = "";
    moneda =
      claveMoneda == "MXN"
        ? (moneda = number == 1 ? " PESO " : " PESOS ")
        : (moneda = number == 1 ? " DÓLAR " : " DÓLARES ");
    return `${monto == 0 ? "CERO " + moneda : cad + moneda}${centavos} ${
      claveMoneda == "MXN" ? "M.N." : claveMoneda
    }`;
  },

  //rellenar lo que falta a un monto
  agregarFaltante(monto, cantidad, split, tipo) {
    //2500.00 | 6 | '.' | 0 -- Después del split contará la cantidad que necesita, si vienen dos ceros agregará cuatro ceros
    let total = monto.toString();
    //total = total.indexOf('.') != -1 ? total : total.padEnd(total.length + 3,'.00');
    const decimales = total.split(split);
    let decimalesFaltantes =
      cantidad - (decimales.length > 1 ? decimales[1].length : 0);
    return total.padEnd(total.length + decimalesFaltantes, tipo);
  },

  regresarValorMoneda(monto, simbolo) {
    return (
      (simbolo ? "$" : "") +
      parseFloat(monto)
        .toFixed(2)
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
        .toString()
    );
  },

  //Sacar nombre y ruta de un archivo
  obtenerNombreRutaArchivo(rutaCompleta) {
    // ejemplo de ruta "ausa-finanzas/finanzas/factura/PDF/PDFPRUEBA.pdf"
    let ruta = rutaCompleta;
    let temp = ruta.split("/");
    let nombreArchivo = temp[temp.length - 1];
    var lastIndex = ruta.lastIndexOf("/" + nombreArchivo);
    ruta = ruta.substring(0, lastIndex);
    var data = new Map();
    data.set("nombre", nombreArchivo);
    data.set("ruta", ruta);
    return data;
  },

  //Descargar Archivos desde una url con fetch
  descargaArchivo(url, filename, type) {
    fetch(url)
      .then((resp) => resp.arrayBuffer())
      .then((resp) => {
        const file = new Blob([resp], { type: type });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = filename;
        link.click();
      });
  },
  //Descargar Archivos desde una url con Blob
  descargarArchivoConBlob(vm, data, filename, type) {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    var blob = new Blob([data], { type: type }),
      url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = `${filename}_${vm.$moment().format("YYYY-MM-DD_hh:mm:ss_a")}`;
    a.click();
    window.URL.revokeObjectURL(url);
  },

  copiarTexto(id, vm, title, timer, cortartexto, numeroCaracteres) {
    var valor =
      cortartexto != undefined
        ? document.getElementById(id).value.substring(numeroCaracteres, 0)
        : document.getElementById(id).value;
    var input = document.createElement("input");
    document.body.appendChild(input);
    input.value = valor;
    input.select();
    document.execCommand("copy", false);
    input.remove();
    vm.$swal({
      type: "success",
      title: title,
      text: valor,
      showConfirmButton: false,
      timer: timer,
    });
  },
  copiarTextoPlano(vm, title, timer, texto) {
    var valor = texto;
    var input = document.createElement("input");
    document.body.appendChild(input);
    input.value = valor;
    input.select();
    document.execCommand("copy", false);
    input.remove();
    vm.$swal({
      type: "success",
      title: title,
      text: valor,
      showConfirmButton: false,
      timer: timer,
    });
  },

  //Remueve el objeto duplicado de un arreglo
  removerDuplicado(arreglo, key) {
    const unique = arreglo
      .map((e) => e[key])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter((e) => arreglo[e])
      .map((e) => arreglo[e]);
    return unique;
  },
  //ObtenerEl RouterName apartir del aiclave
  obtenerRouterName(aiclave) {
    switch (aiclave) {
      case "26":
        return "ReporteDetalleGD";
        break;
      case "1":
        return "DetalleExpJur";
        break;
      case "5":
        return "DetalleRCMedico";
        break;
      case "23":
        return "DetalleRLV";
        break;
      case "24":
        return "DetalleRobo";
        break;
    }
  },

  async guardarEnSesionInfoReporte(data, nombre) {
    let formdata = new FormData();
    formdata.append("data", JSON.stringify(data));

    let encriptado = await Axios.post(
      `${domain.domainNameForApi}EncriptarDatos`,
      formdata
    );
    sessionStorage.removeItem(nombre);
    sessionStorage.setItem(nombre, encriptado.data);
  },

  async obtenerSessionReporte(nombre) {
    let formdata = new FormData();
    formdata.append("data", sessionStorage.getItem(nombre));
    let datos = await Axios.post(
      `${domain.domainNameForApi}DesencriptarDatos`,
      formdata
    );
    return datos.data;
  },

  async obtenerFechaHoraBase() {
    let datos = await Axios.post(
      `${domain.domainNameForApi}ObtenerFechaHoraBase`
    );
    return datos.data;
  },

  async deleteSession(nombre) {
    sessionStorage.removeItem(nombre);
  },
  //async guardarSessionVariable(data, nombre) {
  //    let formdata = new FormData();
  //    formdata.append("data", data);

  //    let encriptado = await Axios.post(`${domain.domainNameForApi}EncriptarDatos`, formdata);
  //    sessionStorage.removeItem(nombre);
  //    sessionStorage.setItem(nombre, encriptado.data);
  //},

  //setTimeout(function() {
  //    console.log("Hola Mundo");
  //}, 2000);

  recurse() {
    //console.log("Recursivo");
    //setTimeout(this.recurse, 4000);
  },

  //Regresa si el reporte esta activo
  async getReporteEstatus(vm) {
    //let datos = JSON.parse(sessionStorage.getItem('reporte'));
    let datos = await this.obtenerSessionReporte("reporte"); //se tiene que pasar como variable
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    formData.append("aiclave", datos.aiclave);
    let response = await Axios.post(
      `${domain.domainNameForApi}VerificarEstadoReporte`,
      formData
    );
    //let response = await vm.axios.post(`${vm.domain.domainNameForApi}VerificarEstadoReporte`, formData);
    return response.data[0].Estatus;
  },

  async variables() {
    let response = await Axios.post(`${domain.domainNameForApi}Variables`);
    return response.data;
  },

  //TOKENISA UN OBJETO:
  generateJsonToken(object) {
    var token = jwt.sign(object, privateKey);
    let formattedToken = token.replaceAll(".", "$");
    return formattedToken;
  },

  //TOKENISA UN OBJETO:
  getJsonTokenData(token) {
    let unFormatToken = token.replaceAll("$", ".");
    try {
      var decoded = jwt.verify(unFormatToken, privateKey);
      return decoded;
    } catch (err) {
      //TODO: throw 404 or 500 idk.. :V
    }
  },
  async exportToExcel(datos, nombreArchivo, cellColored, headerColored) {
    try {
      let tabla = datos;
      const uniqueKeysSet = new Set(tabla.flatMap((obj) => Object.keys(obj)));
      const uniqueKeysArray = Array.from(uniqueKeysSet);

      const workbook = await xlsxPopulate.fromBlankAsync();
      const sheetName = "Hoja";
      const sheet = workbook.addSheet(sheetName, 0);

      await workbook.activeSheet(sheet);

      // Encabezados
      uniqueKeysArray.forEach((header, colIndex) => {
        if (header != "color" && header != "colorLetra") {
          if (headerColored == true) {
            const cell = sheet.cell(1, colIndex + 1);
            cell.value(header);
            cell.style({
              fill: "006699",
              fontColor: "ffffff",
              bold: true,
            });
          } else {
            sheet.cell(1, colIndex + 1).value(header);
          }
        }
      });

      tabla.forEach((item, rowIndex) => {
        const row = sheet.row(rowIndex + 2);

        const cellStyle = workbook.styleSheet().createStyle({
          border: true,
          borderColor: "000000",
        });

        cellStyle.style("border", true);
        cellStyle.style("borderColor", "000000");

        Object.entries(item).forEach(([key, value], colIndex) => {
          const pattern = /[\u0000-\u001F\u007F]/g;

          if (key !== "color" && key !== "colorLetra") {
            const cell = row.cell(colIndex + 1);

            if (typeof value === "string") {
              let formattedValue = value.replace(pattern, "");
              cell.value(formattedValue);
            } else {
              cell.value(value);
            }

            if (cellColored) {
              cellStyle.style("fill", item.color);
              cellStyle.style("fontColor", item.colorLetra);
            }

            cell._style = cellStyle;
          }
        });
      });

      // Ajustar el ancho de columnas basado en el contenido más largo de cada columna
      tabla.forEach((item) => {
        Object.values(item).forEach((value, colIndex) => {
          if (value != null) {
            const valueSt = value.toString();

            const column = sheet.column(colIndex + 1);
            const columnWidth = valueSt.length * 1.5; // Ajusta según tus preferencias

            column.width(columnWidth);
            if (columnWidth < 10) {
              column.width(15);
            }
          }
        });
      });

      // Crear archivo Excel y descargar
      const blob = await workbook.outputAsync();
      const url = URL.createObjectURL(
        new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const a = document.createElement("a");
      a.href = url;
      a.download = nombreArchivo + ".xlsx";
      a.click();

      // Liberar el objeto URL
      URL.revokeObjectURL(url);
    } catch (error) {
      console.log("Error en creacion de excel: ", error);
    }
  },

  async Asistencia() {
    let formdata = new FormData();
    formdata.append("uslogin", this.ObtenerUserName());
    let response = await Axios.post(
      `${domain.domainNameForApi}Asistencia`,
      formdata
    );
    return response.data;
  },
  ValidarPass(pass) {
    var _temp = "";
    var _fortTop = 0,
      _forttmp = 0,
      _fortaleza = 0;
    var _longitud = 0;
    var _compl = 0;
    var _I = 0;
    var _cont = 0;
    var _ctemp = "";
    var _subcad = "";
    var _repTipo = new Array(3);
    var _existeEnArreglo = 0;
    _temp = pass;
    if (_temp.length != 0) {
      _longitud = _temp.length;
    }
    _fortTop = 12.5;
    _compl = 0;
    _fortaleza = 0;
    for (_cont = 0; _cont <= _longitud - 1; _cont++) {
      if (_longitud > 1) {
        _ctemp = _temp.charAt(_cont);
        _I = this.CharTipo(_ctemp);
        _subcad = _temp.substr(0, _cont + 1);
        if (_ctemp == _temp.charAt(_cont - 1)) {
          _compl = 0.25;
        } else {
          if (this.Yaexiste(_ctemp, _subcad) > 2) {
            _compl = 0.5;
          } else {
            _compl = 1;
          }
        }
        if (this.BuscarElementoenArray(_repTipo, _I)) {
          if (this.YaExisteTipo(_I, _subcad) > 2) {
            _compl = _compl / this.YaExisteTipo(_I, _subcad);
          } else {
            _compl = _compl * 1;
          }
        } else {
          this.InsertaArreglo(_repTipo, _I);
          _compl = _compl * 1;
        }
      } else {
        _compl = 1;
      }
      _forttmp = _fortTop * _compl;
      _fortaleza = _fortaleza + _forttmp;
      if (_fortaleza > 100) {
        _fortaleza = 100;
      }
    }
    return parseInt(_fortaleza);
  },
  InsertaArreglo(Aelemento, EaInsertar) {
    for (var j = 0; j <= Aelemento.length; j++) {
      if (Aelemento[j] == "" || Aelemento[j] == undefined) {
        Aelemento[j] = EaInsertar;
        break;
      }
    }
  },
  CharTipo(c) {
    var _ValorRetorno = 0;
    var RegExpMayusculas = /[A-Z]/;
    if (c.match(RegExpMayusculas) && c != "") {
      _ValorRetorno = 1;
    } else {
      var RegExpminusculas = /[a-z]/;
      if (c.match(RegExpminusculas) && c != "") {
        _ValorRetorno = 2;
      } else {
        var RegExpnumeros = /[0-9]/;
        if (c.match(RegExpnumeros) && c != "") {
          _ValorRetorno = 3;
        } else {
          var RegExpCharEspecial = /[~!@#$%^_&*)+(-,{>.}`|:;<]/;
          if (c.match(RegExpCharEspecial) && c != "") {
            _ValorRetorno = 4;
          }
        }
      }
    }
    return _ValorRetorno;
  },

  Yaexiste(c, temp) {
    var _cont = 0;
    var _vtemp = 0;
    for (_cont = 0; _cont <= temp.length; _cont++) {
      if (c == temp.charAt(_cont)) {
        _vtemp = _vtemp + 1;
      }
    }
    return _vtemp;
  },

  YaExisteTipo(i, temp) {
    var _cont = 0;
    var _vtemp = 0;
    for (_cont = 0; _cont <= temp.length; _cont++) {
      if (i == this.CharTipo(temp.charAt(_cont))) {
        _vtemp = _vtemp + 1;
      }
    }
    return _vtemp;
  },

  BuscarElementoenArray(Aelemento, Eabuscar) {
    var bBuscar = false;

    for (var j = 0; j <= Aelemento.length; j++) {
      if (Eabuscar == Aelemento[j]) {
        bBuscar = true;
        break;
      }
    }
    return bBuscar;
  },
  //Historial de busqueda
  async HistorialBusqueda(item, cliente) {
    let datos, nuevo, icono, url, ai;
    let historial = [];
    let frmdata = new FormData();
    frmdata.append("uslogin", this.ObtenerUserName());
    await SerBusqueda.ObtenerHistorial(frmdata).then((respo) => {
      if (respo) historial = JSON.parse(respo);
      else historial = [];
    });

    let from = new FormData();
    from.append("aiclave", parseInt(item.aiclave));
    await SerBusqueda.ObtenerIconoHistorial(from).then((data) => {
      if (data.success == true) {
        icono = data.result[0].icon;
        ai = data.result[0].ai;
      }
    });

    if (historial.length == 0) {
      historial.push({
        nrreporte: item.nrreporte,
        svindice: item.svindice,
        aiclave: item.aiclave,
        cliente: cliente,
        icon: icono,
        ai: ai,
      });
    } else {
      let indice = historial.filter(
        (obj) =>
          parseInt(obj.nrreporte) === parseInt(item.nrreporte) &&
          parseInt(obj.svindice) === parseInt(item.svindice)
      );

      if (indice.length > 0) {
        for (var i in historial) {
          let indice = historial.findIndex(
            (x) =>
              parseInt(x.nrreporte) === parseInt(item.nrreporte) &&
              parseInt(x.svindice) === parseInt(item.svindice)
          );
          if (indice != -1) historial.splice(indice, 1);
        }
        historial.unshift({
          nrreporte: item.nrreporte,
          svindice: item.svindice,
          aiclave: item.aiclave,
          cliente: cliente,
          icon: icono,
          ai: ai,
        });
      } else {
        if (historial.length < 20) {
          historial.unshift({
            nrreporte: item.nrreporte,
            svindice: item.svindice,
            aiclave: item.aiclave,
            cliente: cliente,
            icon: icono,
            ai: ai,
          });
        } else {
          historial.splice(historial.length - 1);
          historial.unshift({
            nrreporte: item.nrreporte,
            svindice: item.svindice,
            aiclave: item.aiclave,
            cliente: cliente,
            icon: icono,
            ai: ai,
          });
        }
      }
    }
    let formdata = new FormData();
    formdata.append("json", JSON.stringify(historial));
    formdata.append("uslogin", this.ObtenerUserName());
    await SerBusqueda.GuardarHistorial(formdata).then((data) => {});
  },

  RenovateSessionTime() {
    var d = new Date();
    d = new Date(d.getTime() + 1000 * 7200); // Segundos literalmente pj: 60 = 1 minuto, 300 = 5 minutos , 600 = 10 minutos... etc.
    document.cookie =
      "SessionTime" +
      "=" +
      "Active" +
      "; expires=" +
      d.toGMTString() +
      "; path=/;";
  },
  async ObtenerPermisosGenerales(tipo) {
    var formData = new FormData();
    formData.append("tipo", tipo);
    await Axios.post(`${domain.domainNameForApi}ObtenerPermisosGenerales`);
    let response = await Axios.post(
      `${domain.domainNameForApi}ObtenerPermisosGenerales`,
      formData
    );
    return response.data;
  },
  async ObtenerURL(reporte) {
    //let reporte = await MetodosGenerales.obtenerSessionReporte("reporte");
    let asistenciaurl = "";
    let formData2 = new FormData();
    formData2.append("nrreporte", reporte.nrreporte);
    formData2.append("svindice", reporte.svindice);
    await Asistencia.ObtenerUrl(formData2).then((data) => {
      if (data.success == true) {
        asistenciaurl = domain.domainName + data.result;
      } else asistenciaurl = "";
    });

    return asistenciaurl;
  },
  ObtenerUserName() {
    //console.log(document.cookie);
    let cokies = document.cookie.split(";");
    let cokie = "";
    for (let i = 0; i < cokies.length; i++) {
      if (
        cokies[i].split("=")[0] == " name" ||
        cokies[i].split("=")[0] == "name"
      ) {
        cokie = cokies[i].split(",")[1];
      }
    }

    return cokie;
  },
  EsEntornoDePruebas() {
    return domain.prueba;
  },
  SanitizarTexto(texto) {
    //Agregar mas conforme sea necesario estos son los simbolos que estaremos remplazando
    const pattern = /[\u0000-\u001F\u007F]/g;
    if (typeof texto === "string") {
      let formattedTexto = texto.replace(pattern, "");
      return formattedTexto;
    } else {
      return texto;
    }
  },
  async ValidarEFirma(efirma, fk1, fk2, tabla, uslogin, proceso, fk3) {
    var formData = new FormData();
    formData.append("usfirma", efirma);
    formData.append("fk1", fk1);
    formData.append("fk2", fk2);
    formData.append("tabla", tabla);
    formData.append("uslogin", uslogin);
    formData.append("proceso", proceso);
    formData.append("fk3", fk3);

    let response = await Axios.post(
      `${domain.domainNameForApi}ValFirmaElectronica`,
      formData
    );

    return response.data;
  },
  async encryptData(data) {
    let formdata = new FormData();
    formdata.append("data", JSON.stringify(data));

    let encriptado = await Axios.post(
      `${domain.domainNameForApi}EncriptarDatos`,
      formdata
    );
    return encriptado.data;
  },

  async decryptData(data) {
    let formdata = new FormData();
    formdata.append("data", data);
    let descenciptado = await Axios.post(
      `${domain.domainNameForApi}DesencriptarDatos`,
      formdata
    );
    return descenciptado.data;
  },
};
